/*
  ============================================================
  Goods Scene - Product Card
  Compatibility overflow detection.

  PURPOSE (deliberately narrow):
  Answer ONE yes/no question per card - did the 3-line clamped
  compatibility list actually overflow? It does NOT count how many
  models were hidden. No numeric remainder is ever calculated.

  PROGRESSIVE ENHANCEMENT DIRECTION IS INTENTIONAL:
  Liquid renders "and more" already visible whenever a product has 4+
  compatible models (the safety net). This script then becomes
  authoritative in BOTH directions by adding `--checked`:
    --checked                 -> hide (script ran, no overflow)
    --checked + --overflowing -> show (script ran, real overflow)
  If the script never runs, `--checked` is absent and the Liquid safety
  net stands - over-shown at worst, never silently hidden.

  PERFORMANCE:
  All layout READS happen first, all WRITES second, so a grid of
  80 cards costs one layout pass rather than 80 forced reflows.
  ============================================================
*/
(function () {
  'use strict';

  var SELECTOR = '.gs-compat-block';
  var CHECKED_CLASS = 'gs-compat-block--checked';
  var OVERFLOW_CLASS = 'gs-compat-block--overflowing';

  // Sub-pixel line heights make scrollHeight/clientHeight differ by ~1px even
  // when nothing is clipped. Only treat a real extra line as overflow.
  var TOLERANCE = 4;

  function syncOverflowState() {
    var blocks = document.querySelectorAll(SELECTOR);
    if (!blocks.length) return;

    var results = [];

    // Pass 1 - READ ONLY. Never touch the DOM in this loop.
    for (var i = 0; i < blocks.length; i++) {
      var text = blocks[i].querySelector('.gs-compat');
      if (!text) continue;
      results.push({
        block: blocks[i],
        overflowing: text.scrollHeight - text.clientHeight > TOLERANCE
      });
    }

    // Pass 2 - WRITE ONLY.
    for (var j = 0; j < results.length; j++) {
      results[j].block.classList.add(CHECKED_CLASS);
      results[j].block.classList.toggle(OVERFLOW_CLASS, results[j].overflowing);
    }
  }

  var resizeTimer = null;
  function onResize() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncOverflowState, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncOverflowState);
  } else {
    syncOverflowState();
  }

  // Web fonts change text metrics after first paint - re-check once they land.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncOverflowState).catch(function () {});
  }

  window.addEventListener('load', syncOverflowState);
  window.addEventListener('resize', onResize);

  // Collection filtering and search replace the grid via AJAX; re-check after.
  document.addEventListener('shopify:section:load', syncOverflowState);
  window.addEventListener('pageshow', syncOverflowState);

  if (window.MutationObserver) {
    var grid = document.getElementById('ProductGridContainer');
    if (grid) {
      new MutationObserver(onResize).observe(grid, { childList: true, subtree: true });
    }
  }
})();
